// Tipos de ausencia y su color (usado en formularios y calendarios).
export const TIPOS = [
  { value: "vacaciones", label: "Vacaciones", color: "#2563eb" },
  { value: "incapacidad", label: "Incapacidad", color: "#dc2626" },
  { value: "permiso", label: "Permiso", color: "#d97706" },
  { value: "home_office", label: "Home office", color: "#16a34a" },
  { value: "otro", label: "Otro", color: "#7c3aed" },
] as const;

export function tipoColor(t: string): string {
  return TIPOS.find((x) => x.value === t)?.color ?? "#64748b";
}

export function tipoLabel(t: string): string {
  return TIPOS.find((x) => x.value === t)?.label ?? t;
}

export const MESES = [
  "Ene", "Feb", "Mar", "Abr", "May", "Jun",
  "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
];

export function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

// Días hábiles (lunes a viernes) entre dos fechas ISO, inclusive. Si se pasa
// `festivos` (Set de fechas ISO YYYY-MM-DD), también los excluye.
/** Política MPP: la solicitud se hace en la quincena ANTERIOR a la del goce.
 *  Inicio día 1–15 → límite = último día del mes anterior; día 16–fin → día 15. (ISO) */
export function fechaLimiteSolicitud(fechaInicioISO: string): string {
  const [y, m, d] = fechaInicioISO.split("-").map(Number);
  if (d <= 15) {
    const prev = new Date(y, m - 1, 0); // día 0 del mes m-1 (0-based) = último día del mes anterior
    return `${prev.getFullYear()}-${pad2(prev.getMonth() + 1)}-${pad2(prev.getDate())}`;
  }
  return `${y}-${pad2(m)}-15`;
}

export function hoyISO(): string {
  const t = new Date();
  return `${t.getFullYear()}-${pad2(t.getMonth() + 1)}-${pad2(t.getDate())}`;
}

export function diasHabiles(fiISO: string, ffISO: string, festivos?: Set<string>): number {
  const start = new Date(fiISO + "T00:00:00");
  const end = new Date(ffISO + "T00:00:00");
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) return 0;
  let count = 0;
  const d = new Date(start);
  while (d <= end) {
    const wd = d.getDay();
    if (wd !== 0 && wd !== 6) {
      const iso = `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
      if (!festivos || !festivos.has(iso)) count++;
    }
    d.setDate(d.getDate() + 1);
  }
  return count;
}

// Días hábiles de [fiISO, ffISO] recortado a la ventana [lowISO, highISO].
export function diasHabilesClip(
  fiISO: string,
  ffISO: string,
  lowISO: string,
  highISO: string,
  festivos?: Set<string>,
): number {
  const fi = fiISO > lowISO ? fiISO : lowISO;
  const ff = ffISO < highISO ? ffISO : highISO;
  if (fi > ff) return 0;
  return diasHabiles(fi, ff, festivos);
}
